import React ,{useState,useEffect, useRef } from 'react';
import { useLocation,useNavigate} from 'react-router-dom';
import Easyrecce from './Easyrecce';
import SpotLight from './SpotLight';
import Clients from './Clients';
import {getHomepageImage,userVerify, getSafetyFAQ} from'../../services/routes.services';
import {Loader} from '../Common/Common/Loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SeoAnalytics from '../Common/Common/SeoAnalytics';
import Index from './EasyrecceIndex';
import Accordion from 'react-bootstrap/Accordion';
import CommonStyle from '../Styles/Common.module.css';
import FontStyle from '../Styles/FontStyle.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col'; 
import parse   from "html-react-parser";
import EasyRecceVideo from '../../assest/videos/easyrecce_video.mp4';
import ClientRequest from '../Browse/ClientRequest';

const HomeRoute=()=>{
    const [homeContent, setHomeContent] = useState([]);
    const [sliderContent, setSliderContent] = useState([]);
    const [blogContent, setBlogContent] = useState([]);
    const [categoryContent, setCatrgoryContent] = useState([]);
    const [locationsContent, setLocationsContent] = useState([]);
    const [testimonialContent, setTestimonialContent] = useState([]);
    const [spinner, setSpinner] = useState(false);
    const [resetToken,setResetToken]=useState();
    const [resetPopup,setResetPopup]=useState(false);
    const [safetyFAQ, setSafetyFAQ] =   useState([]);
    const easyrecceRef = useRef(null);
    const [searchBox, setSearchBox ] = useState(false);
    const [playVideo, setPlayVideo] = useState(false);
    const [openForm, setOpenForm] = useState(false)
    
    const locationReqHandel=()=>{
        setOpenForm(true)
    }


    const showSearchHandler = ()=>{
        setSearchBox(true)
    }
    const closeSearchHandler = ()=>{
        setSearchBox(false)
    }
   
    useEffect(() => {
        //alert(paramValue);
    
        setSpinner(true);
        
        getHomepageImage().then((res) => {
                    setSpinner(false);
                    setHomeContent(res.data.data);
                    setSliderContent(res.data.data.slider)
                    setBlogContent(res.data.data.blog)
                    setCatrgoryContent(res.data.data.browse_category)
                    setLocationsContent(res.data.data.public_home)
                    setTestimonialContent(res.data.data.testimoinal)
            
                })
                getSafetyFAQ().then((res) => {
                    setSafetyFAQ(res.data[0].faq)
                })
                .catch(error => {
                    console.log(error);
                })

     }, []);
     console.log(locationsContent)
     const handleCallback = (data) => {};
    return(
        <div>
          <SeoAnalytics pageID="1"/>
            {
                homeContent!='' ?
                    (
                    <>     
                        <div className='whatApp'>
                        <a href={`https://wa.me/${"7710810801"}`} target="_blank" rel="noopener noreferrer" className="whatsapp-button">
                            <svg width="54" height="55" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32.6158" r="32" fill="#00A552"/><path d="M42.8144 21.6669C41.4473 20.2904 39.8201 19.1994 38.0275 18.4571C36.2347 17.7148 34.3121 17.3362 32.3715 17.3432C29.7774 17.3458 27.2293 18.0294 24.9827 19.3257C22.736 20.622 20.8696 22.4855 19.5703 24.7295C18.271 26.9735 17.5845 29.5193 17.5795 32.1118C17.5745 34.7045 18.2511 37.2528 19.5417 39.5018L17.4531 47.1613L25.2853 45.1113C27.448 46.3137 29.8781 46.9546 32.3529 46.975C36.2871 46.9751 40.062 45.4222 42.8558 42.6543C45.6499 39.8866 47.2368 36.1279 47.2713 32.1964C47.2583 30.2345 46.8577 28.2946 46.0929 26.4877C45.3282 24.6808 44.214 23.0426 42.8144 21.6669ZM32.3715 44.4218C30.1668 44.4233 28.0023 43.831 26.1058 42.7073L25.6583 42.4277L21.0149 43.6577L22.2457 39.1291L21.9473 38.6632C20.3608 36.1039 19.7687 33.0518 20.2832 30.0853C20.7976 27.1188 22.3829 24.444 24.7387 22.5674C27.0945 20.6909 30.0571 19.743 33.0654 19.9033C36.0737 20.0636 38.9189 21.321 41.0615 23.4373C43.4037 25.7262 44.7445 28.8484 44.7911 32.1218C44.7617 35.3942 43.4401 38.5225 41.1141 40.8261C38.7883 43.1295 35.6461 44.422 32.3715 44.4218ZM39.1035 35.2155C38.7305 35.0291 36.9217 34.1346 36.586 34.0227C36.2503 33.9109 35.9893 33.8364 35.7468 34.2091C35.3821 34.7087 34.9897 35.1877 34.572 35.6441C34.3669 35.905 34.1431 35.9236 33.7701 35.6441C31.6437 34.8043 29.8721 33.2575 28.7538 31.2646C28.3622 30.6123 29.1268 30.6496 29.8354 29.2518C29.8878 29.151 29.915 29.0392 29.915 28.9257C29.915 28.8122 29.8878 28.7004 29.8354 28.5996C29.8354 28.4132 28.9962 26.5868 28.6979 25.86C28.3995 25.1332 28.1011 25.245 27.8587 25.2264H27.1314C26.943 25.2293 26.7574 25.2723 26.5869 25.3527C26.4165 25.433 26.2652 25.5488 26.1431 25.6923C25.7247 26.0989 25.3983 26.5904 25.186 27.1337C24.9737 27.677 24.8804 28.2594 24.9123 28.8418C25.0293 30.236 25.5546 31.5648 26.4228 32.6623C28.012 35.0399 30.1899 36.966 32.7445 38.2532C34.0844 39.0348 35.6415 39.3617 37.1827 39.185C37.6959 39.0832 38.1821 38.8747 38.6093 38.5728C39.0367 38.2711 39.3957 37.8827 39.6629 37.4332C39.9106 36.8845 39.9885 36.2746 39.8867 35.6814C39.7189 35.495 39.4764 35.4018 39.1035 35.2155Z" fill="white"/></svg>
                        </a>
                         <button type="button" onClick={() => setPlayVideo(true)}>Watch Demo</button>
                        </div>
                        <Index easyrecceRef={easyrecceRef} />
                        <div ref={easyrecceRef}>
                        
                        </div>
                        {/* <button type='button' onClick={locationReqHandel}>Click Here to submit your filming location requirements</button> */}
                        <SpotLight locations={locationsContent}/>
                        <Easyrecce />
                        <div className={CommonStyle.whiteBg}>
                        <Clients Client={testimonialContent}/>
                        </div>
                        <div className={CommonStyle.safetyFaq}>
                            <Container>
                                <Row className={CommonStyle.PhotographyBoxSpace}>
                                    <Col>
                                        <div className={CommonStyle.centerAlign}>
                                            
                                            <h2 className={FontStyle.Axiforma300 + ' ' + FontStyle.BlackLightColor}>FAQS</h2>
                                        </div>
                                        <div className="faqAccordion listSpaceFAQ">
                                        <Accordion defaultActiveKey="4">
                                            {safetyFAQ.map((safetyFAQContent) => {
                                                return (
                                                    <Accordion.Item
                                                        eventKey={`${safetyFAQContent.id}`}
                                                        key={safetyFAQContent.id}
                                                    >
                                                        <Accordion.Header>{safetyFAQContent.title}</Accordion.Header>
                                                        <Accordion.Body>{parse(`${safetyFAQContent.content}`)}</Accordion.Body>
                                                    </Accordion.Item>
                                                );
                                            })}
                                        </Accordion>

                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                            {playVideo && (
                                <div className="easyindexVideo">
                                    <div className="easyCont">
                                        <button type="button" className="closeButton" onClick={() => setPlayVideo(false)}>X</button>
                                        <video src={EasyRecceVideo} width="100%" height="100%" loop autoPlay className="backgroundVideo"></video>
                                    </div>
                                </div>
                            )}
                    </>
                    )
                    :('')
            }
            {spinner && 
                <Loader />
            }
          
            {/* {openForm &&
                <ClientRequest onClose={() => setOpenForm(false)} />
            } */}
            
        </div>
    )
}

export default HomeRoute;